// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-no-rights {
  width: 480px;
}
.dialog-no-rights .button2 {
  margin-right: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogNoRights/DialogNoRights.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,kBAAA;AACR","sourcesContent":[".dialog-no-rights {\n  width: 480px;\n}\n.dialog-no-rights .button2 {\n  margin-right: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
